import cssVars from 'css-vars-ponyfill'
import 'lazysizes'
import 'lazysizes/plugins/rias/ls.rias'
import objectFitImages from 'object-fit-images'

const widths = [180, 540, 720, 900, 1080, 1296, 1512, 1728, 1944]
const root = document.documentElement

setScrollbarWidth()

function setScrollbarWidth() {
    const root = document.documentElement

    document.body.style.overflow = 'scroll'
    root.style.setProperty('--scrollbar-width', `${window.innerWidth - root.clientWidth}px`)

    document.body.style.overflow = ''
}


root.style.setProperty('--scrollbar-width', `${ window.innerWidth - root.clientWidth }px`)

lazySizes.cfg.loadMode = 1
lazySizes.cfg.rias.widths = widths

document.addEventListener('lazyriasmodifyoptions', ( e => {
    return event => {
        const maxWidth = Number(event.target.getAttribute('data-max-width'))
        if(maxWidth) event.detail.widths = widths.filter( w => w <= maxWidth )
    }
})())

objectFitImages()
cssVars()
